import { Cluster, ClusterStatus } from '@cast/types';

import { isKentEligibleCluster } from '@cast/shared-cluster-context-data-access';

export const useIsReadOnlyClusterEligibleForRebalancingPlanCreation = (
  cluster: Cluster
): boolean => {
  return (
    isKentEligibleCluster(cluster) && cluster.status === ClusterStatus.READ_ONLY
  );
};
